import { Injectable } from '@angular/core';
import maplibregl from 'maplibre-gl';

@Injectable({
  providedIn: 'root',
})
export class MapService {
  private mapRegistry: { [key: string]: maplibregl.Map } = {};

  registerMap(id: string, map: maplibregl.Map): void {
    this.mapRegistry[id] = map;
  }

  getMap(id: string): maplibregl.Map | undefined {
    return this.mapRegistry[id];
  }

  async waitForAllMapsToRender(): Promise<void> {
    const renderPromises = Object.values(this.mapRegistry).map((map) => {
      return new Promise<void>((resolve) => {
        map.on('idle', () => {
          resolve();
        });
        map.triggerRepaint();
      });
    });

    await Promise.all(renderPromises);
  }
}
